module.exports = __webpack_public_path__ + "static/media/partner-8.080fac6c.webp";